import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedComics from './components/FeaturedComics';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '韩漫画网 - 韩漫免费在线看',
    description: '韩漫画网是专业的韩漫免费在线阅读平台，提供下拉式漫画大全，涵盖恋爱、奇幻、动作等多种类型，每日更新。',
    url: 'https://hanmanhua.com',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        { '@type': 'SiteNavigationElement', name: '精选推荐' },
        { '@type': 'SiteNavigationElement', name: '漫画分类' },
        { '@type': 'SiteNavigationElement', name: '最新更新' },
        { '@type': 'SiteNavigationElement', name: '人气排行榜' },
      ],
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedComics />
          <CategoryNav />
          <LatestUpdates />
          <PopularRanking />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}